/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Box, ImageListItem, Stack } from "@mui/material";
import GalleryContext from "./context";
import GalleryCard from "components/model-selector/gallery/gallery-card";
import SelectedBadge from "components/model-selector/gallery/buttons/selected-badge";

const SelectGalleryItem = (props) => {
    const isSelected = props.isSelected;
    const model = props.model;

    const ctx = useContext(GalleryContext);
    const { setSelectedModel } = ctx;

    const selectModel = (e, model) => {
        e.stopPropagation();
        setSelectedModel(model);
    };

    return (
        <>
            <ImageListItem cols={2}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "4px",
                        paddingLeft: "4px",
                    }}
                >
                    <GalleryCard model={model} selectModel={selectModel}>
                        <Stack direction='row' justifyContent='flex-start' sx={{ width: "100%" }}>
                            {/*  to add selection capabilities  */}
                            {isSelected && <SelectedBadge color='#00685E' />}
                        </Stack>
                    </GalleryCard>
                    {/*<Stack direction='row' justifyContent='flex-end' sx={{ width: '100%'}} >*/}
                    {/*    <EditButton*/}
                    {/*        model={model}*/}
                    {/*        color='#DFDFDF'*/}
                    {/*        onClick={onEditModelClick}*/}
                    {/*    />*/}
                    {/*</Stack>*/}
                </Box>
            </ImageListItem>
        </>
    );
};
export default SelectGalleryItem;
